/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ServiceProviderCategoryEnum } from './serviceProviderCategoryEnum';

export interface VasProviderRole { 
    _id?: string;
    id?: number;
    serviceProviderName?: string;
    serviceProviderId?: string;
    roleName?: string;
    authenticationId?: string;
    serviceProviderPhoneNumber?: string;
    serviceProviderEmail?: string;
    serviceProviderFirstName?: string;
    serviceProviderLastName?: string;
    serviceProviderCategory?: ServiceProviderCategoryEnum;
    dateTimeCreated?: Date;
    isActive?: boolean;
    countryName?: string;
    countryId?: number;
    countryCode?: string;
    addressLocation?: string;
}